export const i18n = {
  defaultLocale: 'fa',
  locales: ['en', 'fa'],
  langDirection: {
    // fr: 'ltr',
    // ar: 'rtl',
    en: 'ltr',
    fa: 'rtl'
  }
} as const

export type Locale = (typeof i18n)['locales'][number]

//french and arabic hass been removed frim this config and the language drop down
//we can add them back by adding these languages to tje locales and enabling them in language drop down and i28n config (here)
